module.exports = __webpack_public_path__ + "img/colored_section-5.60fad9f0.svg";